<template>
  <div class="vote-view-wrapper">
    <div class="logo-vote">
      <div class="block-bg"></div>
      <img src="@/assets/logo_vote.png" />
    </div>
    <div><h1>It is no longer possible to register</h1></div>
  </div>
</template>

<script>
export default {
  name: "v-disabled",
};
</script>

<style lang="scss">
.vote-option-wrapper {
  display: flex;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid #bebebe;
  .radio-vote-btn {
    span {
      input {
        height: 100%;
        margin: 0 20px;
      }
    }
  }
  .vote-btn-text {
    span {
      float: left;
      &.fixwidth {
        width: 120px;
        font-weight: bold;
      }
    }
  }
}
.submit-btn {
  width: 100%;
  height: 30px;
}
.app-wrapper {
  margin: 0 !important;
  padding: 0 !important;
}
.logo-vote {
  width: 100%;
  height: 120px;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  img {
    height: 120px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
  }
  .block-bg {
    height: 120px;
    width: 100%;
    position: absolute;
    top: 43px;
    background: #009cb4;
    z-index: 50;
  }
}

.vote-view-wrapper {
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  .intro-text {
    span {
      display: block;
      margin: 10px 0;
    }
  }
  .vote-view {
    padding: 20px;
    border: 1px solid #bebebe;
    margin: 0 auto;
    max-width: 500px;
    .form-tmp-row {
      display: flex;
      width: 100%;
      input {
        flex-grow: 1;
      }
    }

    .bottom-border-tr {
      border-bottom: 1px solid #bebebe !important;
      display: block;
      td {
        padding: 0 5px;
      }
    }
  }
}
</style>
